import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CounterState {
    isLogin: boolean;
    minorMode: boolean;
}

const initialState: CounterState = {
    isLogin: false,
    minorMode: false,
};

export const counterSlice = createSlice({
    name: 'counter',
    initialState,
    reducers: {
        setAuthIsLogin: (state, action: PayloadAction<boolean>) => {
            state.isLogin = action.payload;
        },
        setMinorMode: (state, action: PayloadAction<boolean>) => {
            state.minorMode = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setAuthIsLogin, setMinorMode } = counterSlice.actions;

export default counterSlice.reducer;
